/* ============================================================
   ENEMY CLOTHING — ANIMATIONS
   enemy-animations.js
   ============================================================ */

(function () {
  'use strict';

  /* ── Hero load animation ───────────────────────────────────── */
  function initHero() {
    const hero = document.querySelector('.ec-hero');
    if (!hero) return;

    const delays = { eyebrow: 0.1, subtitle: 0.45, buttons: 0.6 };

    hero.querySelector('.ec-hero__eyebrow')?.style.setProperty('transition-delay', `${delays.eyebrow}s`);
    hero.querySelector('.ec-hero__subtitle')?.style.setProperty('transition-delay', `${delays.subtitle}s`);
    hero.querySelector('.ec-hero__buttons')?.style.setProperty('transition-delay', `${delays.buttons}s`);

    const lines = hero.querySelectorAll('.ec-hero__title-line');
    lines.forEach((line, i) => {
      line.style.setProperty('transition-delay', `${0.2 + i * 0.15}s`);
    });

    requestAnimationFrame(() => {
      setTimeout(() => hero.classList.add('is-loaded'), 50);
    });
  }

  /* ── Intersection Observer for scroll-in animations ────────── */
  function initScrollAnimations() {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      document.querySelectorAll('.anim-fade-up, .anim-fade-in').forEach(el => {
        el.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const delay = el.dataset.animDelay || 0;
          setTimeout(() => el.classList.add('is-visible'), parseFloat(delay) * 1000);
          observer.unobserve(el);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    document.querySelectorAll('.anim-fade-up, .anim-fade-in').forEach(el => {
      observer.observe(el);
    });
  }

  /* ── Card stagger in grid ───────────────────────────────────── */
  function initCardStagger() {
    const grids = document.querySelectorAll('.ec-grid');
    grids.forEach(grid => {
      const cards = grid.querySelectorAll('.ec-card');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const card = entry.target;
            const idx = Array.from(cards).indexOf(card) % 3;
            card.style.setProperty('transition-delay', `${idx * 0.08}s`);
            card.classList.add('is-visible');
            observer.unobserve(card);
          }
        });
      }, { threshold: 0.05 });

      cards.forEach(card => {
        card.classList.add('anim-fade-up');
        observer.observe(card);
      });
    });
  }

  /* ── Parallax on hero image ─────────────────────────────────── */
  function initParallax() {
    const heroImg = document.querySelector('.ec-hero__image[data-parallax]');
    if (!heroImg) return;

    const speed = parseFloat(heroImg.dataset.parallax) || 0.3;
    let ticking = false;

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrollY = window.scrollY;
          heroImg.style.transform = `translateY(${scrollY * speed}px)`;
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── Page transition ────────────────────────────────────────── */
  function initPageTransitions() {
    const overlay = document.createElement('div');
    overlay.className = 'ec-page-transition';
    document.body.appendChild(overlay);

    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href]');
      if (!link) return;

      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || link.target === '_blank') return;
      if (new URL(href, location.origin).origin !== location.origin) return;

      e.preventDefault();
      overlay.classList.add('is-leaving');

      setTimeout(() => {
        window.location.href = href;
      }, 220);
    });

    window.addEventListener('pageshow', () => {
      overlay.classList.remove('is-leaving');
    });
  }

  /* ── Init all ───────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    initHero();
    initScrollAnimations();
    initCardStagger();
    initParallax();
    initPageTransitions();
  });
})();
